import React, { ChangeEvent } from 'react';
import { TimetableTimeSlotsFilters, TimetableTimeSlotStatusType } from '@api/graphql/types';
import InputDate from '@components/Form/InputDate';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface Props {
    onSubmit: (values: TimetableTimeSlotsFilters) => void;
    value: TimetableTimeSlotsFilters;
}

interface StateType {
    value: TimetableTimeSlotsFilters;
    changed: boolean;
}

type PropType = Props & InjectedIntlProps;

class TimetableListFilter extends React.Component<PropType, StateType> {
    public constructor(props: PropType) {
        super(props);

        const { id, range_date, status, timetable_sector_id } = props.value;
        this.state = {
            changed: false,
            value: {
                id,
                range_date,
                status,
                timetable_sector_id,
            },
        };
    }

    public componentWillReceiveProps(props: PropType) {
        const { id, range_date, status, timetable_sector_id } = props.value;
        this.setState({changed: false, value: {
            id,
            range_date,
            status,
            timetable_sector_id,
        }});
    }

    private onChangeHandler = (value: any, name: keyof TimetableTimeSlotsFilters) => {
        const newValue = {
            ...this.state.value,
            [name]: value,
        };
        this.props.onSubmit(newValue);
    }

    public render() {
        return (
            <div className="m-b-lg">
                <form className="row" onSubmit={(e) => { e.preventDefault(); this.props.onSubmit(this.state.value); }} >
                    <div className="col-md-6">
                        <InputDate name="range_date" value={this.state.value.range_date} onChange={this.onChangeHandler} isClearable={false} />
                    </div>
                    <div className="col-md-6">
                        <select name="status" className="form-control" value={this.state.value.status || ''} onChange={(e: ChangeEvent<HTMLSelectElement>) => {
                            const status: (TimetableTimeSlotStatusType | undefined) = (e.currentTarget.value as TimetableTimeSlotStatusType) || undefined;
                            this.onChangeHandler(status, 'status');
                        }}>
                            <option value="">---</option>
                            <option value={TimetableTimeSlotStatusType.ACTIVE}>{this.props.intl.formatMessage({id: 'module.timetable.status.ACTIVE'})}</option>
                            <option value={TimetableTimeSlotStatusType.INACTIVE}>{this.props.intl.formatMessage({id: 'module.timetable.status.INACTIVE'})}</option>
                            <option value={TimetableTimeSlotStatusType.FULL}>{this.props.intl.formatMessage({id: 'module.timetable.status.FULL'})}</option>
                        </select>
                    </div>
                </form>
            </div>
        );
    }
}

export default compose(
    injectIntl,
)(TimetableListFilter);



// WEBPACK FOOTER //
// ./src/modules/Timetable/components/TimetableListFilter.tsx